import { render } from "./BasicFormModal.vue?vue&type=template&id=416e52f0&scoped=true"
import script from "./BasicFormModal.vue?vue&type=script&lang=js"
export * from "./BasicFormModal.vue?vue&type=script&lang=js"

import "./BasicFormModal.vue?vue&type=style&index=0&id=416e52f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-416e52f0"

export default script